import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { OverlayModule } from '@angular/cdk/overlay';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { DialogModule } from '@syncfusion/ej2-angular-popups';

const matImports = [MatButtonModule, MatFormFieldModule, MatInputModule,
  MatCardModule, MatTableModule,
  MatPaginatorModule, MatSortModule, MatSidenavModule,
  MatToolbarModule, MatListModule, MatMenuModule, MatSnackBarModule,
  MatTooltipModule, MatTabsModule,
  MatSelectModule, MatIconModule, MatCheckboxModule,
  MatChipsModule, MatAutocompleteModule, MatDialogModule,
  MatExpansionModule, MatDatepickerModule,
  MatNativeDateModule, MatBadgeModule, OverlayModule,
  MatGridListModule, DialogModule, ClipboardModule];
@NgModule({
  imports: [...matImports],
  exports: [...matImports],
  declarations: []
})
export class MaterialHelperModule { }
